import { useEffect } from "react";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { useWorkspaces } from "@/lib/api/queries";
import { resolveWorkspace } from "@/lib/workspace";

type WorkspaceState = {
  workspaceId: string | null;
  setWorkspaceId: (id: string | null) => void;
};

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      workspaceId: null,
      setWorkspaceId: (id) => set({ workspaceId: id }),
    }),
    { name: "maknangi-workspace" },
  ),
);

/** 지금 보고 있는 워크스페이스. 저장된 id 가 목록과 어긋나면 스스로 고친다.
 *
 * 워크스페이스를 쓰는 화면은 전부 이걸 지나간다 — 저장된 id 를 그대로 믿으면
 * `/people` 을 북마크로 바로 열었을 때(저장된 id 가 없거나 남의 것) 빈 화면이 된다.
 */
export function useCurrentWorkspace() {
  const workspaceId = useWorkspaceStore((s) => s.workspaceId);
  const setWorkspaceId = useWorkspaceStore((s) => s.setWorkspaceId);
  const { data: workspaces, isLoading } = useWorkspaces();
  const workspace = resolveWorkspace(workspaces ?? [], workspaceId);

  useEffect(() => {
    if (workspace && workspace.id !== workspaceId) setWorkspaceId(workspace.id);
  }, [workspace, workspaceId, setWorkspaceId]);

  return { workspaces: workspaces ?? [], workspace, isLoading };
}
